import BigCircleBtn from 'components/buttons/BigCircleBtn'
import CallContext from 'context/call/CallContext'
import useTranslation from 'hooks/useTranslation'
import React, { useContext } from 'react'
import { STATUS } from 'utils/constants'

const CallBtn = () => {
  const { isBlocked, status, makeCall, cancelCall, endCall } = useContext(CallContext)
  const { t } = useTranslation('help')

  const { action, interior } = ((s) => {
    if (isBlocked) return {
      action: undefined,
      interior: t('call')
    }

    switch (s) {
      case STATUS.succeed: return {
        action: endCall,
        interior: t('end')
      }
      case STATUS.pending: return {
        action: cancelCall,
        interior: t('cancel')
      }
      default: return {
        action: () => {
          const query = new URLSearchParams(window.location.search)
          const warehouseId = query.get('warehouseId')
          makeCall(true, { warehouseId })
        },
        interior: t('call')
      }
    }
  })(status)

  return (
    <div style={isBlocked ? { opacity: '0.4' } : {}}>
      <BigCircleBtn
        status={status}
        action={action}
        interior={interior}
      />
    </div>
  )
}

export default CallBtn